// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiWaveCreditNft } from '../models/ApiWaveCreditNft';
import { HttpFile } from '../http/http';

export class ApiCreateNewWaveVotingConfigOneOf4 {
    'credit_type': ApiCreateNewWaveVotingConfigOneOf4CreditTypeEnum;
    'credit_nfts': Array<ApiWaveCreditNft>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "credit_type",
            "baseName": "credit_type",
            "type": "ApiCreateNewWaveVotingConfigOneOf4CreditTypeEnum",
            "format": ""
        },
        {
            "name": "credit_nfts",
            "baseName": "credit_nfts",
            "type": "Array<ApiWaveCreditNft>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiCreateNewWaveVotingConfigOneOf4.attributeTypeMap;
    }

    public constructor() {
    }
}


export enum ApiCreateNewWaveVotingConfigOneOf4CreditTypeEnum {
    CardSetTdh = 'CARD_SET_TDH'
}

